export const paths = [{ "tag": "path", "att": { "d": "M6 6h12v12H6V6z" } }];
export const iconName = 'stop';
export const stop = { iconName, paths };
export default paths;
